import Vue from 'vue'
import VTooltip from 'v-tooltip'

// Vue Click Outside
import vClickOutside from 'v-click-outside'

// Custom directives
import vZoom from '@/directives/zoom'

// Filter
import '@/filters'

// Vue resources
import VueResource from 'vue-resource'

import VueCookie from 'vue-cookie'

// plugins
import functionsPlugin from '@/plugins/functions'
import AhaAudience from '@ahaslides-product/stpancras-storybook-app/src/AhaAudience'
// 3rd parties
import PortalVue from 'portal-vue'

import Config from '@/config'
import { shouldSendApiCredentials } from '@/utils/apiCredentials.utils'
import '@/utils/system/SystemConnector'

import mqttSubscribers from '@/mqtt/subscribers'
import sentry from '@/3rd-parties/sentry'
import mixpanelUtils from './utils/mixpanel.utils'

import store from './store'
import i18n from './i18n'
import router from './router'

import '@/assets/css/font-awesome.min.css'
import '@/assets/fontawesome/css/all.css'
import '@/assets/scss/iconAnimate.scss'
import '@/assets/scss/dialog.scss'
import '@/assets/scss/checkbox.scss'
import '@/assets/scss/flex.scss'
import '@/assets/scss/variables.scss'
import '@/assets/scss/base.scss'
import '@/assets/scss/global.scss'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import '@/assets/scss/custom.scss'

import './assets/tailwind.css'
import './assets/scss/custom-tailwind.scss'

import App from './App.vue'

Vue.config.productionTip = false
if (Config.env === 'staging' || Config.env === 'develop') {
  Vue.config.devtools = true
}

// Initialize 3rd party services
sentry.init()
mixpanelUtils.init()
mqttSubscribers.init()

// use custom plugins
Vue.use(functionsPlugin)

// use v-tooltip
Vue.use(VTooltip, {
  defaultOffset: 8,
  defaultTrigger: 'hover click',
})

Vue.directive('zoom', vZoom)
Vue.use(vClickOutside)
Vue.use(VueResource)
Vue.http.interceptors.push((request) => {
  request.credentials = shouldSendApiCredentials(request.url, Config.baseUrl, window.location.href)
})
Vue.use(PortalVue)
Vue.use(VueCookie)
Vue.use(AhaAudience)

// eslint-disable-next-line import/prefer-default-export
export const app = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
